import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import TextTruncate from 'react-text-truncate'
import { fetchTopic, fetchTopicCloud } from '../../../actions/topicclouds'
import { direct, supplemental, more } from '../../../utils/messages'

export default class Item extends Component {
  constructor(props) {
    super(props)
    this.state = {
      truncated: true
    }
    this.onDeleteClickBound = this.onDeleteClick.bind(this)
    this.onChangeContextBound = this.onChangeContext.bind(this)
    this.onTopicClickBound = this.onTopicClick.bind(this)
  }

  render() {
    const { topic, lines, hideActions } = this.props
    const directContext = topic.context === 'direct'
    const klass = hideActions ? '' : 'editing'

    return (
      <li className={`quest-topic ${klass}`} id={topic.topic_id}>
        <div className="row">
          <div className="left">
            <div className="cloud-name">{topic.topic_cloud.name}</div>
            <span className="carat"></span>
            <div className="parent-name">{topic.parent.name}</div>
            <div className="name" onClick={this.onTopicClickBound}>
              {topic.name}
            </div>
            <div className="description">
              {this.state.truncated ? (
                <TextTruncate
                  line={lines}
                  truncateText="..."
                  text={topic.description}
                  textTruncateChild={
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault()
                        this.setState({ truncated: false })
                      }}
                    >
                      &nbsp; {more}
                    </a>
                  }
                />
              ) : (
                topic.description
              )}
            </div>
          </div>
          <div className={`right ${klass}`}>
            {hideActions ? (
              <div className="context">{topic.context}</div>
            ) : (
              <div>
                <div className="context-toggle">
                  <div>
                    <input
                      type="radio"
                      id={`context-${topic.topic_id}-direct`}
                      name={`topiccontext-${topic.topic_id}`}
                      className="form-control direct"
                      checked={directContext}
                      onChange={this.onChangeContextBound}
                    />
                    <label htmlFor={`context-${topic.topic_id}-direct`}>
                      {direct}
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id={`context-${topic.topic_id}-supplemental`}
                      name={`topiccontext-${topic.topic_id}`}
                      className="form-control supplemental"
                      checked={!directContext}
                      onChange={this.onChangeContextBound}
                    />
                    <label htmlFor={`context-${topic.topic_id}-supplemental`}>
                      {supplemental}
                    </label>
                  </div>
                </div>
                <div
                  className="trash"
                  onClick={this.onDeleteClickBound}
                  data-id={topic.topic_id}
                >
                  &nbsp;
                </div>
              </div>
            )}
          </div>
        </div>
      </li>
    )
  }

  onDeleteClick(e) {
    const topicId = JSON.parse(e.target.dataset.id)
    this.props.deleteTopic(topicId)
  }

  onChangeContext(e) {
    const id = JSON.parse(e.target.name.split('-')[1])
    const context = e.target.id.split('-')[2]
    this.props.changeContext(id, context)
  }

  onTopicClick() {
    const { dispatch, topic } = this.props
    dispatch(push('/topicclouds'))
    // When navigating directly from a quest or actvity, the default fetching that happens in
    // topicclouds actions and topicclouds container causes errors, e.g. tries to auto fetch first topiccloud,
    // and then first topic for that topiccloud. Here, I'm navigating to that section first, which will load
    // the default (here: bad) data, then, timing the other actions/requests to overwrite those props and render
    // the correct topic cloud and topic. A similar issue exists if the user has no cached data and
    // tries to nav to a quest-linked topic without first visiting the topics section (by header click).
    // TODO: Refactor this and the accompanying actions/container for a more elegant solution
    setTimeout(() => {
      dispatch(fetchTopicCloud(topic.topic_cloud.id))
    }, 500)
    setTimeout(() => {
      dispatch(fetchTopic(topic.parent.id))
    }, 1000)
  }
}

Item.propTypes = {
  topic: PropTypes.object,
  deleteTopic: PropTypes.func,
  changeContext: PropTypes.func,
  lines: PropTypes.number,
  dispatch: PropTypes.func,
  hideActions: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/quest/topics/Item.js